export const actionKey = '@@HISTORY';
export const reduxKey = '@@HISTORY';

//# sourceMappingURL=constants.js.map